import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/components/DynamicText";
import { DynamicHtml } from "@/components/DynamicHtml";
import RateUs from "./RateUs.svg";
import Phone from "@/assets/Phone.svg";
import Email from "@/assets/Email.svg";
import { getGlobal } from "@/getters/getGlobal";
import { getRoute } from "@/routes";

export default function Results({ className, url_slug }) {
  const global = getGlobal();
  const email = global["contact.details.email"];
  const phone = global["contact.details.phone"];

  return (
    <div className={clsx(className, classes.results)}>
      <Container fluid="lg" className="py-5 py-md-6">
        <DynamicText path={`page.case.study.${url_slug}.results.title`} tag="h2" className="mb-4 mb-md-5">
          The Results
        </DynamicText>
        <Row>
          <Col xs={12} md={6}>
            <DynamicHtml path={`page.case.study.${url_slug}.results.text`} className="me-4 mb-5">
              <p>
                With extra training support, the Trust successfully completed the project. By hiring the right experts,
                at the right time, the Trust saw end-user adoption rates soar. With end-users on board, the Trust was
                able to achieve its initial project outcomes.
              </p>
              <p>
                <strong>Connecting Experts</strong>
                <br />
                Looking to hire an EPR trainer? Wanting hiring options for your EPR system project? Contact the team
                today.
              </p>
            </DynamicHtml>
            <Stack className="flex-row mb-4 mb-md-0" gap={{ xs: 2, md: 4 }}>
              {phone && (
                <Button variant="blue" className="d-flex align-items-center" href={`tel:${phone}`}>
                  <Phone className="me-2" />
                  Call
                </Button>
              )}
              {email && (
                <Button variant="blue-dark" className="d-flex align-items-center" href={`mailto:${email}`}>
                  <Email className="me-2" />
                  Email
                </Button>
              )}
              <Button variant="grey-dark" className="d-flex align-items-center" href={getRoute("contact")}>
                Contact
              </Button>
            </Stack>
          </Col>
          <Col xs={12} md={6}>
            <a href="" className="d-block w-100">
              <RateUs />
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
